export { default } from "./src/image-v2";
export type { UniformImageV2Props } from "./src/image-v2";
